<div class="upper-space">
  <div class="d-flex">
    <div class="design-edit-container">
      <div class="d-flex">
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            placeholder="Selecteer medewerker"
            [(ngModel)]="adjustment.adjustmentDesigner"
            [compareWith]="compareEntities"
            (ngModelChange)="save.emit()"
          >
            <mat-option *ngFor="let option of designerChoices" [value]="option">
              {{ option.user?.firstName | personName: option.user?.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="left-space">
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Selecteer een datum"
              [(ngModel)]="adjustment.currentDesignDate"
              (ngModelChange)="save.emit()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="less-mat-form-field-bottom-padding">
        <div class="width-75">
          <textarea-input
            [placeholder]="'Interne communicatie over het ontwerp'"
            [initContent]="adjustment.extraInfoDesign"
            [sensitive]="true"
            [client]="true"
            (answer)="extraInfoDesignChanged($event)"
          >
          </textarea-input>
        </div>
        <div class="width-75">
          <textarea-input
            [placeholder]="'Opvolging van dit ontwerp - Interne feedback'"
            [initContent]="adjustment.designFollowUp"
            [sensitive]="true"
            [client]="true"
            (answer)="designFollowUpChanged($event)"
          >
          </textarea-input>
        </div>
      </div>

      <div class="d-inline-flex">
        <div
          *ngIf="contactName?.length > 0 && contactEmail?.length > 0"
          class="left-fifteen-space clickable send-mail-button"
        >
          <a
            href="{{
              contactEmail
                | mailSubjectBodyLink
                  : projectId
                  : contactName
                  : adjustment.projectPlacement?.address?.line1
                  : adjustment.projectPlacement?.address?.city
                  : adjustment.projectPlacement?.address?.postalCode
                  : 'Hierbij het ontwerp.'
                  : 'Job'
            }}"
            target="_blank"
            >Ontwerp versturen</a
          >
        </div>

        <button
          *ngIf="ipBoard?.boardPart?.sign != null"
          class="btn btn-print mr-2"
          mat-flat-button
          (click)="goToBord(ipBoard.boardPart.sign.id)"
        >
          Ga naar voorraadbord
        </button>
      </div>

      <div class="upper-space registered-action-display-container">
        <div>
          <mat-checkbox
            [(ngModel)]="adjustment.designSentToCustomer"
            (ngModelChange)="save.emit()"
          >
            <ng-container *ngIf="adjustment.designSentLog == null">
              <i class="secondary-color">Ontwerp #{{ projectId }} verstuurd</i>
            </ng-container>
            <ng-container *ngIf="adjustment.designSentLog != null">
              <i>{{
                adjustment.designSentLog.date
                  | formatDate: '':'dd/MM/yyyy HH:mm'
              }}</i>
            </ng-container>
          </mat-checkbox>
        </div>
        <div
          *ngIf="adjustment.designSentLog != null"
          class="align-with-registration-checkbox"
        >
          <i>{{
            adjustment.designSentLog.by?.firstName
              | personName: adjustment.designSentLog.by?.lastName
          }}</i>
        </div>
        <div
          *ngIf="adjustment.designSentLog != null"
          class="align-with-registration-checkbox"
        >
          <i class="secondary-color">Ontwerp #{{ projectId }} verstuurd</i>
        </div>
      </div>

      <div class="left-fifteen-space">
        <mat-checkbox
          [(ngModel)]="adjustment.designApproved"
          (ngModelChange)="designApprovedChanged()"
        >
          <i class="strong">Goedgekeurd</i>
        </mat-checkbox>
        <ng-container *ngIf="adjustment.designApproved">
          <div
            *ngIf="adjustment.designApprovalRegistration != null"
            class="left-space registered-action-display-container"
          >
            <div>
              <i>{{
                adjustment.designApprovalRegistration.date
                  | formatDate: '':'dd/MM/yyyy HH:mm'
              }}</i>
            </div>
            <div>
              <i>{{
                adjustment.designApprovalRegistration.by?.firstName
                  | personName
                    : adjustment.designApprovalRegistration.by?.lastName
              }}</i>
            </div>
            <div>
              <i class="secondary-color">Ontwerp #{{ projectId }} akkoord</i>
            </div>
          </div>
          <div class="left-space width-75">
            <textarea-input
              [placeholder]="'Akkoord klant - Persoonsnaam noteren'"
              [initContent]="adjustment.designApprovalFollowup"
              [sensitive]="true"
              (answer)="designApprovalFollowupChanged($event)"
            >
            </textarea-input>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="extra-design-asset-container">
      <file-picker
        [inputProjectPlacement]="adjustment.projectPlacement"
        [formSection]="'extraDesign'"
        [uploadButtonLabel]="'Ontwerp toevoegen'"
        (answer)="extraDesignAssetsChanged()"
        (assetDeleted)="extraDesignAssetsChanged()"
      ></file-picker>
    </div>
  </div>
</div>
